import { Component } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { BookResponse } from "@builtbybros/al-model";
import { Observable, Subject } from "rxjs";

import { AlertService } from '../shared/alert.service';
import { HttpService } from '../shared/http.service';
import { QueryParam } from '../shared/query-param';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.scss']
})
export class RankingComponent {
  books = [];
  btnMsg = 'Confirmar';
  h1 = 'Ranking';
  booksReady = false;
  bookUrl = '/Book/';

  msg = {
    rankingError: 'Ocurrió un error al actualizar el ranking',
    rankingSuccess: 'Ranking actualizado correctamente',
  };

  // Search
  searchResultItems: Observable<BookResponse.BookExcerpt[]>;
  searching = false;

  private searchTerms = new Subject<string>();

  constructor(
    private dragulaService: DragulaService,
    private httpService: HttpService,
    private alertService: AlertService,
  ) {
    // dragulaService.drag.subscribe((value) => {
    //   this.onDrag(value.slice(1));
    // });
    // dragulaService.drop.subscribe((value) => {
    //   this.onDrop(value.slice(1));
    // });
    // dragulaService.over.subscribe((value) => {
    //   this.onOver(value.slice(1));
    // });
    // dragulaService.out.subscribe((value) => {
    //   this.onOut(value.slice(1));
    // });
  }

  ngOnInit() {
    this.httpService.getWithParams('/Book/Ranking', [], BookResponse.All)
      .subscribe(
        response => {
          this.books = response.objects;
          this.booksReady = true;
        }
      );

    this.searchResultItems = this.searchTerms
      .debounceTime(300)        // wait 300ms after each keystroke before considering the term
      .distinctUntilChanged()   // ignore if next search term is same as previous
      .do(() => this.searching = true)
      .switchMap(term => term ? this.searchItem(term) : Observable.of<BookResponse.BookExcerpt[]>([]))
      .catch(error => {
        this.alertService.error(error);
        return Observable.of<BookResponse.BookExcerpt[]>([]);
      })
      .do(() => this.searching = false);
  }

  // private onDrag(_args) {
  //   // let [e, el] = args;
  //   // do something
  // }

  // private onDrop(_args) {
  //   // let [e, el] = args;
  //   // do something
  // }

  // private onOver(_args) {
  //   // let [e, el, container] = args;
  //   // do something
  // }

  // private onOut(_args) {
  //   // let [e, el, container] = args;
  //   // do something
  // }

  submitForm() {
    const body = {
      ranking: this.books.map(({ id }) => id),
    };

    this.httpService.updateRaw('/Ranking/Update', body)
      .subscribe(
        _response => this.alertService.success(this.msg['rankingSuccess']),
        _error => this.alertService.error(this.msg['rankingError']),
      );
  }

  addItem(value: number) {
    let responseExpected = new BookResponse.Book();
    this.httpService.get(this.bookUrl, value, responseExpected)
      .subscribe(
        createResponse => {
          if (createResponse) {
            this.books.push(createResponse);
          }
        }
      );
  }

  search(term: string): void {
    this.searchTerms.next(term);
  }

  private searchItem(query: string): Observable<BookResponse.BookExcerpt[]> {
    const params = [
      new QueryParam('pagination', '10'),
      new QueryParam('query', query),
    ];
    const searchUrl = '/Book/All';
    const resultObservable: Observable<BookResponse.All> = this.httpService.getWithParams(
      searchUrl,
      params,
      BookResponse.All,
    );

    return resultObservable
      .map(
        itemResponse => itemResponse.objects,
        _error => [],
      );
  }

  cleanSearch() {
    this.searchTerms.next('');
  }

  delete(id) {
    if (confirm('eliminar?')) {
      this.books.splice(this.books.findIndex((item) => {
        return item.id === id;
      }), 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/ranking/ranking.component.ts